import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';


export type AutomationTarget = 'partstrader' | 'ccc' | 'tesla' | 'opstrax' | 'mitchell' | 'collisionlink';
interface WorkflowItem {
    key: string;
    label: string;
    target: AutomationTarget;
    canCancel?: boolean
}

export interface OrderWorkflowStatus {
    pending: WorkflowItem[];
    inProgress: WorkflowItem[];
}

const getOrderWorkflowStatus = async (
    sessionId: string,
    orderId: string,
): Promise<OrderWorkflowStatus | null> => {
    const { status, data } = await axios.get(`${API_URL}/order/workflow-status`, {
        params: { orderId },
        headers: { Authorization: sessionId },
        validateStatus: (s) => s === 200 || s === 204,
    });
    if (status === 204) return null;
    return data;
};

export const useGetOrderWorkflowStatus = (
    orderId: string,
    refetchInterval: number,
) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/order/workflow-status', orderId],
        queryFn: () => getOrderWorkflowStatus(sessionContext?.sessionId ?? '', orderId),
        enabled: !!sessionContext?.sessionId && !!orderId,
        staleTime: 10 * 1000,
        refetchInterval,
    });
};
